export default class Pattern {
	static get(content, pattern, fallback) {
		if (typeof fallback == 'undefined')
			fallback = '';

		const match = content.match(pattern);
		return match ? match[1] : fallback;
	}

	static list(content, pattern) {
		return [...content.matchAll(pattern)];
	}

	static replace(content, search, replace) {
		let data = content;
		while (search.test(data))
			data = data.replace(search, replace);

		return data;
	}
}